'use client';

import { useEffect, useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

export default function Markdown({ children }) {
  const [contents, setContents] = useState(children);

  // Only update the description if it's changed
  // This prevents videos being cut off due to re-rendering
  useEffect(() => {
    if (children) {
      setContents((old) => {
        return old !== children ? children : old;
      });
    }
  }, [children]);

  // Custom renderer for iframe
  const customRenderers = useMemo(
    () => ({
      iframe: (iframe) => {
        if (!iframe?.src?.includes('youtube')) {
          return null;
        }
        return <iframe {...iframe} />;
      },
    }),
    []
  );

  return (
    <ReactMarkdown
      className="markdown"
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]} // Use the rehypeRaw plugin
      components={customRenderers} // Use custom renderers
    >
      {contents}
    </ReactMarkdown>
  );
}
